module.exports = __webpack_public_path__ + "img/LOGO-SERVICETEC.957e7487.png";